import { useMemo } from 'react';

import { sparkPath } from '../../lib/sparkline';

interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
  stroke?: string;
}

export function Sparkline({
  data,
  width = 80,
  height = 24,
  stroke = 'currentColor',
}: SparklineProps) {
  const d = useMemo(() => sparkPath(data, width, height), [data, width, height]);
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden>
      <path d={d} fill="none" stroke={stroke} strokeWidth={1.2} />
    </svg>
  );
}
